 <template>
  <div>
    <v-row>
      <v-col cols="6" class="mt-4">
        <v-text-field          
          dense 
          v-model="banco_origen" 
          :rules="[rules.required]"
          label="Banco"></v-text-field>
      </v-col>
      <v-col cols="6" class="mt-4">
        <v-text-field         
          dense 
          :rules="[rules.required]"
          v-model="referencia_bancaria" 
          label="Referencia"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="6">
        <label for="date"
            ><DatePicker 
            label="Fecha de pago"
            name="date"
            :max="today"
            @change="fecha_pago_usuario = $event"
            :rules="[rules.required]"
        /></label>
        </v-col>   
        <v-col sm="6">
            <time-picker
            label="Hora de pago"            
            :initialHour="hora_pago_usuario"           
            @change="hora_pago_usuario = $event"
            ></time-picker>
        </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="numero_movimiento"   
          :rules="[rules.required]"                      
          label="No. Movimiento / Folio"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          type="number"
          :rules="[rules.required]"
          v-model="monto_reportado"
          name="monto"
          label="Monto reportado"
          prefix="$"
          suffix="MXN"
        />
      </v-col>      
    </v-row>   
  </div>
</template>
 
<script>
import DatePicker from '@/components/DatePicker.vue';
import TimePicker from '@/components/TimePicker2.vue';

export default { 
  components: {
    DatePicker,
    TimePicker,
  },
  props: {
    payment: {
      type: Object,
      required: true,
    }, 
  },
  data() {
    return {      
      banco_origen:'',
      fecha_pago_usuario: '',
      hora_pago_usuario: '',
      referencia_bancaria: '',  
      numero_movimiento: '',  
      monto_reportado: 0,              // valor numérico puro            
      fecha_confirmacion_usuario: '',
      today: new Date().toISOString().split("T")[0], // formato 'YYYY-MM-DD'  
      rules: {
        required: (value) => !!value || 'Required.',                    
        min: (v) => (v && v.length >= 1) || 'Min 1 characters',
        len30: (v) => (v && v.length <= 30) || 'Max 30 caracteres',
        len60: (v) => (v && v.length <= 60) || 'Max 60 caracteres',
      },      
    };
  },
  mounted() {
    if (this.payment.id) {
      this.banco_origen= this.payment.banco_origen  || '';
      this.fecha_pago_usuario= this.payment.fecha_pago_usuario  || this.getTodayDate();
      this.hora_pago_usuario= this.payment.hora_pago_usuario  || '00:00';
      this.referencia_bancaria= this.payment.referencia_bancaria  || '';
      this.numero_movimiento= this.payment.numero_movimiento  || '';
      this.monto_reportado= this.payment.monto_reportado || 0;
      this.fecha_confirmacion_usuario= this.payment.fecha_confirmacion_usuario || this.getTodayDate();     
    }
  },
  watch: {
    payment(newValue) {
      if (newValue.id) {
        this.banco_origen= this.payment.banco_origen  || '';
        this.fecha_pago_usuario= this.payment.fecha_pago_usuario  || this.getTodayDate();
        this.hora_pago_usuario= this.payment.hora_pago_usuario  || '00:00';
        this.referencia_bancaria= this.payment.referencia_bancaria  || '';
        this.numero_movimiento= this.payment.numero_movimiento  || '';
        this.monto_reportado= this.payment.monto_reportado || 0;
        this.fecha_confirmacion_usuario= this.payment.fecha_confirmacion_usuario || this.getTodayDate();        
      }
    },
  },
  
  methods: {        
    paymentData() {      
        const payment = {            
            banco_origen: this.banco_origen,
            fecha_pago_usuario: this.fecha_pago_usuario,
            hora_pago_usuario: this.hora_pago_usuario,
            referencia_bancaria: this.referencia_bancaria,  
            numero_movimiento: this.numero_movimiento,  
            monto_reportado: this.monto_reportado, 
            };        
        return {
            id: this.payment.id,
            payment,
        };
    },
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`; // formato 'YYYY-MM-DD'
    },
  },
};
</script>
<style>
.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 1) !important;
}
</style>


<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>


